import { createRef, useContext, useEffect } from "react";
import StuntDriversContext from "./StuntDriversContext.jsx";

const propTypes = {};

const removeStatusClasses = (container) => {
  container.current &&
    container.current
      .querySelectorAll(".driver-rect.active")
      .forEach((a) => a.classList.remove("selected", "active"));
  return;
};

const container = createRef();

const StuntDriversNavigationGraphic = (props) => {
  const {
    activeCategoryId,
    activeSectionId,
    currentSection,
    getCategoriesWithSections,
    handleSelect,
    mergedCategories,
  } = useContext(StuntDriversContext);

  useEffect(() => {
    const boxes = container.current.querySelectorAll(".driver-rect");
    const activeCategories = getCategoriesWithSections().map((cat) => cat.id);

    // remove any previously active category
    removeStatusClasses(container);

    // set current category active
    container.current
      .querySelector(`[data-category=${activeCategoryId}]`)
      .classList.add("selected");

    // bind mouse events to boxes
    boxes.forEach((box) => {
      // Using getAttribute() is required here as IE doesn't support dataset
      // for SVGElement's
      // source: https://caniuse.com/#feat=mdn-api_svgelement_dataset
      const boxCategoryId = box.getAttribute("data-category");

      // mark available categories
      if (activeCategories.indexOf(boxCategoryId) !== -1) {
        box.classList.add("active");

        // NOTE: using onclic to replace the click function and not add many events
        box.onclick = (e) => {
          if (e.target.classList.contains("selected")) return;

          removeStatusClasses(container);

          e.target.classList.add("selected");

          // Using getAttribute() is required here as IE doesn't support dataset
          // for SVGElement's
          // source: https://caniuse.com/#feat=mdn-api_svgelement_dataset
          const clickedCategoryId = e.target.getAttribute("data-category");

          if (activeSectionId) {
            handleSelect(clickedCategoryId, 1);
          } else {
            handleSelect(clickedCategoryId);
          }
        };
      } else {
        box.onclick = () => false;
      }
    });
  }, [
    activeCategoryId,
    activeSectionId,
    currentSection,
    getCategoriesWithSections,
    handleSelect,
    mergedCategories,
  ]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="stunting-drivers-navigation"
      width="105"
      height="75"
      viewBox="0 0 105 75"
      ref={container}
    >
      <g
        className="diagram-overview"
        id="stunting_diagram_overview"
        transform="translate(10, 10)"
      >
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          data-category="ContextAndEnablers"
          id="ContextAndEnablers_overview"
          x="0"
          y="0"
          width="16"
          height="32"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="IncreasedIncome_overview"
          data-category="IncreasedIncome"
          x="20"
          y="0"
          width="16"
          height="19"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="ImprovedFeeding_overview"
          data-category="ImprovedFeeding"
          x="40"
          y="0"
          width="16"
          height="19"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="ImprovedCare_overview"
          data-category="ImprovedCare"
          x="40"
          y="22"
          width="16"
          height="19"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="HealthyHousehold_overview"
          data-category="HealthyHousehold"
          x="40"
          y="44"
          width="16"
          height="16"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="ImprovedDietary_overview"
          data-category="ImprovedDietary"
          x="58"
          y="0"
          width="16"
          height="8"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="LackOfDisease_overview"
          data-category="LackOfDisease"
          x="58"
          y="11"
          width="16"
          height="6"
        ></rect>
        <rect
          className="driver-rect"
          fill="#E6EAEC"
          id="IntergenerationalTransfer_overview"
          data-category="IntergenerationalTransfer"
          x="58"
          y="22"
          width="29"
          height="6"
        ></rect>
        <circle fill="#E6EAEC" cx="84" cy="8" r="5"></circle>
        <circle fill="#E6EAEC" cx="84" cy="8" r="5"></circle>
      </g>
    </svg>
  );
};

StuntDriversNavigationGraphic.propTypes = propTypes;
export default StuntDriversNavigationGraphic;
